import { useEffect, useState } from "react";

export const LOOP_TYPES = ["Full-time", "Contract", "Part-time", "Temporary", "Internship"];
export const LOOP_LEVELS = ["Junior", "Associate", "Senior"];
export const LOOP_SCRAPERS = ["LinkedIn", "Workable", "Indeed", "Glassdoor", "Monster", "Reed", "ZipRecruiter", "Greenhouse", "Lever"];

export function useDebounced(value, ms = 250) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
